//libs
import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';

//selectors
import { getTotalCount } from 'shared/store/listingV2/selectors';

//components
import Placeholder from 'shared/layouts/Listing/components/PLPPlaceholder';
import Layout from 'shared/layouts/Listing/Desktop/components/Layout';

const Content = () => {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  const productCount = useSelector(getTotalCount);

  if (productCount) return <Layout />;
  return <Placeholder />;
};

export default memo(Content);
